module.exports = __webpack_public_path__ + "img/9D.eac3be47.jpg";